import React, { FC, useContext } from "react";
import { LocalizationContext } from "v3/context/localization";
import { FieldInput } from "@pepdirect/v3/ui/FieldInput";
import { Checkbox } from "@pepdirect/v3/ui/Checkbox";
import { FieldTextArea } from "@pepdirect/v3/ui/FieldTextArea";
import { GiftIconSvg } from "@pepdirect/v3/ui/icons";
import {
  StyledCTA,
  StyledCTAIcon,
  StyledForm,
  StyledGiftForm,
  StyledLabel,
  StyledRequiredFields,
} from "./index.styled";

export interface GiftFormValues {
  gifteeEmail: string;
  gifteeMessage: string;
  giftorName: string;
}
interface GiftProps {
  formId?: string;
  isGiftFormOpen?: boolean;
  isGuest: boolean;
  setIsGiftFormOpen: (isOpen: boolean) => void;
}

export const GiftForm: FC<GiftProps> = ({
  formId = "giftInfo",
  isGiftFormOpen = false,
  isGuest,
  setIsGiftFormOpen,
}) => {
  const { localization } = useContext(LocalizationContext);
  const { requiredFieldsText = "Required fields" } =
    localization?.forms?.address || {};

  const {
    sendAsGiftText = "Send this order as a gift",
    infoText = "This will send an email to the recipient with your message (don't worry, we won't spoil the surprise!)",
    emailFieldLabel = "Recipient's Email",
    gifteeFieldLabel = "Your Name",
    messageFieldLabel = "Gift Message (400 character max)",
  } = localization?.checkout?.giftForm || {};

  const onClickCheckbox: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    setIsGiftFormOpen(event.target.checked);
  };

  return (
    <StyledGiftForm>
      <StyledCTA>
        <StyledLabel>
          <Checkbox checked={isGiftFormOpen} onChange={onClickCheckbox} />
        </StyledLabel>
        <StyledCTAIcon>
          <GiftIconSvg />
        </StyledCTAIcon>
        <div>{sendAsGiftText}</div>
      </StyledCTA>

      {isGiftFormOpen && (
        <StyledForm>
          <div>{infoText}</div>
          <StyledRequiredFields>{requiredFieldsText} *</StyledRequiredFields>
          {isGuest && (
            <FieldInput label="Your Email*" name={`shippingAddress.email`} />
          )}
          <FieldInput
            label={emailFieldLabel + "*"}
            name={`${formId}.gifteeEmail`}
          />
          <FieldInput
            label={gifteeFieldLabel + "*"}
            name={`${formId}.giftorName`}
          />
          <FieldTextArea
            label={messageFieldLabel}
            name={`${formId}.gifteeMessage`}
            maxLength={400}
            resize="vertical"
          />
        </StyledForm>
      )}
    </StyledGiftForm>
  );
};
